import { Pipe, PipeTransform } from '@angular/core';
import { IAddress } from '@shared-models/address.model';

@Pipe({ name: 'address' })
export class AddressPipe implements PipeTransform {
	transform(value: IAddress, useBreak: boolean = true): string {
		if (!value) {
			return '';
		}
		if (useBreak) {
			return `${value.street ? value.street : ''}${value.number ? ` ${value.number}` : ''}${
				value.street || value.number ? ',' : ''
			} ${value.postbox ? `${value.postbox},` : ''} \n${value.zipcode ? value.zipcode : ''}  ${
				value.city ? value.city : ''
			}`;
		}
		return `${value.street ? value.street : ''}${value.number ? ` ${value.number}` : ''}${
			value.street || value.number ? ',' : ''
		}  ${value.postbox ? value.postbox : ''} ${value.zipcode ? value.zipcode : ''}  ${
			value.city ? value.city : ''
		}`;
	}
}
